import stageKey from "Utils/stageKey";

const DAY = 86400000;
const BLOCKED = ["OPTED_OUT", "BOUNCED", "DO_NOT_CONTACT"];
const plural = (n, w) => `${n} ${w}${n === 1 ? "" : "s"}`;

const contactFindings = ({
  selection = null,
  totalContacts = 0,
  rows = [],
  now = Date.now(),
  actions = {}
} = {}) => {
  const out = [];
  const list = Array.isArray(rows) ? rows : [];
  if (selection && selection.ids?.length) {
    const picked = Array.isArray(selection.rows) ? selection.rows : [];
    if (selection.withoutEmail > 0) {
      out.push({
        tone: "bad",
        key: "no_email",
        label: `${selection.withoutEmail} selected have no email`,
        text: "They cannot be sequenced. Enrich them first.",
        actions: actions.enrich ? [{ label: "Enrich selected", run: actions.enrich }] : []
      });
    }
    if ((selection.stages || []).some(s => BLOCKED.includes(stageKey(s)))) {
      out.push({
        tone: "warn",
        key: "blocked_selected",
        label: "Opted-out contacts selected",
        text: "Some of these opted out or bounced. Sending to them risks your domain.",
        actions: actions.deselectBlocked ? [{ label: "Remove them", run: actions.deselectBlocked }] : []
      });
    }
    const noOwner = picked.filter(r => !r.owner).length;
    if (noOwner) {
      out.push({
        tone: "warn",
        key: "no_owner_selected",
        label: `${noOwner} selected have no owner`,
        text: "Unowned contacts get no follow-up. Assign them.",
        actions: actions.assignOwner ? [{ label: "Assign owner", run: actions.assignOwner }] : []
      });
    }
    const missing = picked.filter(r => !r.jobTitle || !r.company).length;
    if (missing) {
      out.push({
        tone: "neutral",
        key: "missing_fields_selected",
        label: `${missing} selected missing title or company`,
        text: "Personalisation tokens will send blank. Enrich before sequencing.",
        actions: actions.enrich ? [{ label: "Enrich selected", run: actions.enrich }] : []
      });
    }
    out.push({
      tone: "neutral",
      key: "selected",
      label: `${selection.total || selection.ids.length} selected`,
      text: "Add them to a sequence, tag them, or ask me to compare them to a sequence.",
      actions: actions.addToSequence ? [{ label: "Add to sequence", run: actions.addToSequence }] : []
    });
    return out;
  }
  if (list.length) {
    const never = list.filter(r => !r.lastContactedTs).length;
    if (never) {
      out.push({
        tone: "hot",
        key: "never_contacted",
        label: `${never} on this page never contacted`,
        text: "Saved but nobody has reached out. Put them in a sequence.",
        actions: actions.neverContacted ? [{ label: "Find and sequence them", run: actions.neverContacted }] : []
      });
    }
    const stale = list.filter(r => r.lastContactedTs && now - r.lastContactedTs > 30 * DAY).length;
    if (stale) {
      out.push({
        tone: "warn",
        key: "stale",
        label: `${stale} not contacted in 30+ days`,
        text: "A month of silence. Re-engage or close them out.",
        actions: actions.stale ? [{ label: "Show them", run: actions.stale }] : []
      });
    }
    const seen = new Map();
    list.forEach(r => {
      const e = String(r.email || "").toLowerCase();
      if (e) seen.set(e, (seen.get(e) || 0) + 1);
    });
    const dupes = [...seen.values()].filter(n => n > 1).length;
    if (dupes) {
      out.push({
        tone: "neutral",
        key: "duplicates",
        label: plural(dupes, "possible duplicate"),
        text: "Same email more than once on this page. Merge before they get emailed twice.",
        actions: actions.duplicates ? [{ label: "Find duplicates", run: actions.duplicates }] : []
      });
    }
  }
  const hadRowFindings = out.length;
  if (totalContacts > 20) {
    out.push({
      tone: "neutral",
      key: "describe",
      label: "Filter by describing them",
      text: "Tell me who you want, for example VPs who opened but never replied, and I will find them.",
      actions: actions.describe ? [{ label: "Describe them", run: actions.describe }] : []
    });
  }
  if (totalContacts > 0 && !hadRowFindings) {
    out.push({
      tone: "neutral",
      key: "base",
      label: `${totalContacts} contacts`,
      text: "Select some and I can enrich, sequence or clean them."
    });
  }
  return out;
};

export default contactFindings;
